import { makeStyles, Tooltip, Typography } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';

import React, { useRef, useState } from 'react';
import { useIsMobileSize } from 'src/hooks/useIsMobile';
import { useBlogAction } from './BlogProvider';
import { setSelectedBlog } from './services/blog.reducer';
import { removeHtmlTags } from 'src/utils/helpers/common';
import MediumIcon from 'src/assets/icons/common/MediumIcon';
import { useTranslation } from 'src/app/i18n';
const DEFAULT_TEXT_SIZE = 100;
// interface Props {
//     title: string;
//     content: string;
//     src: string;
// }

const useBlogComponentStyle = makeStyles((theme) =>
    createStyles({
        image: { width: '100%' },
        blogContainer: {
            width: '90%',
            marginLeft: '5%',
            cursor: 'pointer',
            marginBottom: theme.spacing(8)
        },
        imageContainer: { aspectRatio: '1/1', width: '100%', overflow: 'hidden' },
        title: { fontWeight: 600 },
        icon: { fill: theme.palette.primary.main }
    })
);

const BlogComponent = (props: any) => {
    const classes = useBlogComponentStyle();
    const imageRef = useRef<HTMLImageElement | null>();
    const imageContainerRef = useRef<HTMLDivElement | null>();
    const isMobile = useIsMobileSize();
    const [readMore, setReadMore] = useState(false);
    const imageTopLeft = useRef<any>({ top: 0, left: 0, right: 0, width: 0 });
    const dispatch = useBlogAction();
    const { t } = useTranslation('blog');

    return (
        <>
            <div
                className={classes.blogContainer}
                onClick={() => {
                    if (isMobile) {
                        setReadMore((prevState) => !prevState);
                        return;
                    }
                    if (!imageContainerRef.current) return;

                    const bound = imageContainerRef.current.getBoundingClientRect();

                    imageTopLeft.current = {
                        top: bound?.top,
                        left: bound?.left,
                        width: bound?.width,
                        right: bound?.right
                    };
                    dispatch(setSelectedBlog({ ...props, bound }));
                    // dispatch(toggleDetail(true));
                }}>
                <div
                    data-blog-id={props.id}
                    className={classes.imageContainer}
                    ref={(refs) => (imageContainerRef.current = refs)}>
                    <img
                        ref={(refs) => (imageRef.current = refs)}
                        className={classes.image}
                        src={props.src}
                    />
                </div>

                <br />
                <br />

                <Typography color="textPrimary" variant="h6" className={classes.title}>
                    {props.title}
                </Typography>
                <br />

                <Typography color="textPrimary" variant="body2" className={classes.title}>
                    {readMore
                        ? removeHtmlTags(props.content)
                        : removeHtmlTags(props.content).slice(0, DEFAULT_TEXT_SIZE)}
                    ...
                </Typography>
                <Tooltip title={t('onMedium')}>
                    <a href={props.link}>
                        <MediumIcon className={classes.icon} />
                    </a>
                </Tooltip>
            </div>
        </>
    );
};

export default BlogComponent;
